import { jsx as _jsx } from "react/jsx-runtime";
import * as Styled from "./InteractiveMenuListItem.styled";
export const MenuListItemRadio = (_props) => {
    const { checked, disabled, label, value, inputProps, ...props } = _props;
    return (_jsx(Styled.OptionRadio, { checked: checked, disabled: disabled, label: _jsx(Styled.OptionCheckboxLabel, { children: label }), value: value, inputProps: { ...inputProps, "data-primary-focus-target": true }, ...props }));
};
